/**
 * component-countup.js
 * Animates [data-countup] numbers from 0 to their authored value when scrolled
 * into view. Parses the unit out of the string (e.g. "93%", "+150", "98,5%")
 * so the prefix/suffix is preserved and only the number counts up.
 *
 * Fallback-safe: the real value is already rendered in the HTML by Liquid.
 * This script only animates when JS runs AND the user allows motion. If either
 * is false, the authored value simply stays on screen.
 */
(function () {
  if (window.__cgCountUpInit) return;
  window.__cgCountUpInit = true;

  var DEFAULT_DURATION = 1500;
  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Split "<prefix><number><suffix>" and figure out the decimal separator.
  // Heuristic: a separator followed by exactly 1-2 digits is a decimal point
  // ("98,5%" -> 98.5); 3 digits is treated as a thousands separator and stripped
  // ("1,000" -> 1000). Outliers can be handled case-by-case.
  function parse(text) {
    var m = text.match(/^(\D*?)(\d[\d.,\s]*\d|\d)(\D*)$/);
    if (!m) return null;

    var prefix = m[1];
    var raw = m[2].replace(/\s/g, '');
    var suffix = m[3];

    var sepIdx = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
    var value;
    var decimals = 0;
    var sep = '.';

    if (sepIdx > -1) {
      var frac = raw.slice(sepIdx + 1).replace(/[.,]/g, '');
      if (frac.length >= 1 && frac.length <= 2) {
        // decimal
        sep = raw.charAt(sepIdx);
        var intPart = raw.slice(0, sepIdx).replace(/[.,]/g, '');
        decimals = frac.length;
        value = parseFloat(intPart + '.' + frac);
      } else {
        // thousands separator -> strip
        value = parseFloat(raw.replace(/[.,]/g, ''));
      }
    } else {
      value = parseFloat(raw);
    }

    if (isNaN(value)) return null;
    return { prefix: prefix, value: value, decimals: decimals, sep: sep };
  }

  function format(num, decimals, sep) {
    var s = num.toFixed(decimals);
    if (sep === ',') s = s.replace('.', ',');
    return s;
  }

  function animate(el, info, original, duration) {
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var p = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      if (p < 1) {
        el.textContent =
          info.prefix + format(info.value * eased, info.decimals, info.sep) + suffixOf(info, original);
        requestAnimationFrame(frame);
      } else {
        el.textContent = original; // snap to the exact authored string
      }
    }
    requestAnimationFrame(frame);
  }

  // Recover the suffix from the original string (everything after the number).
  function suffixOf(info, original) {
    var m = original.match(/^(\D*?)(\d[\d.,\s]*\d|\d)(\D*)$/);
    return m ? m[3] : '';
  }

  function init() {
    var els = Array.prototype.slice.call(
      document.querySelectorAll('[data-countup]')
    );
    if (!els.length) return;

    var targets = [];
    els.forEach(function (el) {
      var original = el.textContent.trim();
      var info = parse(original);
      if (!info) return; // non-numeric value: leave it untouched

      // Lock the rendered width so dropping to 0 doesn't cause layout shift.
      el.style.minWidth = el.getBoundingClientRect().width + 'px';
      targets.push({ el: el, info: info, original: original });
    });

    if (!targets.length) return;

    // No motion / no IntersectionObserver: leave the authored values as-is.
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var t = entry.target.__cgCountUp;
          io.unobserve(entry.target);
          if (!t || t.done) return;
          t.done = true;

          var duration =
            parseInt(t.el.getAttribute('data-countup-duration'), 10) ||
            DEFAULT_DURATION;

          t.el.textContent =
            t.info.prefix +
            format(0, t.info.decimals, t.info.sep) +
            suffixOf(t.info, t.original);

          animate(t.el, t.info, t.original, duration);
        });
      },
      { threshold: 0.4 }
    );

    targets.forEach(function (t) {
      t.el.__cgCountUp = t;
      io.observe(t.el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
